import React, { Component } from "react";
import { Switch, Route, Redirect } from "react-router-dom";
import { connect } from "react-redux";

import { Empty, Layout } from "antd";
// import Header from "../../components/header";
import LeftNav from "../../components/left-nav";
import ApptListPage from "../appt-list";
import TerminalAccountPage from "../terminal";

//从布局中拿到组件容器
const { Content, Header } = Layout;

//这是后台登录以后的框架页面
class Admin extends Component {
  render() {
    const { userInfo } = this.props;
    // 如果没有登录，跳转到登录页面
    if (!userInfo) {
      return <Redirect to="/login" />;
    }
    // 如果已经登录显示后台Layout页面
    return (
      <Layout>
        {/* <Sider>
          <LeftNav />
        </Sider> */}
        {/* <Layout> */}
        {/* 头部导航 */}
        <Header>
          {/* <Header /> */}
          <LeftNav />
        </Header>
        {/* 内容框 */}
        <Content className="content">
          <Switch>
            {/*如果访问项目的根路径，那么转到home*/}
            <Redirect exact from="/" to="/home" />
            {/* 码头预约 */}
            <Route path="/home" component={ApptListPage} />
            <Route path="/account" component={TerminalAccountPage} />
            {/*上面没有一个匹配，直接显示 not found*/}
            <Route component={Empty} />
          </Switch>
        </Content>
        {/* </Layout> */}
      </Layout>
    );
  }
}

export default connect(
  (state) => ({ userInfo: state.auth.userInfo }),
  {}
)(Admin);
